import { useCallback, useEffect, useMemo, useState } from "react";
import { post } from "../networking/RequestService";

function useGetCourseCategories(params = {}, autoFetch = true) {
    const [courseCategories, setCourseCategories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const memoizedParams = useMemo(() => params, [JSON.stringify(params)]);

    const fetchCourseCategories = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await post({ fn: "getCourseCategories", ...memoizedParams });
            setCourseCategories(response.data.categories);
        } catch (error) {
            setError(error.response?.data?.text || "An unexpected error occurred");
        } finally {
            setLoading(false);
        }
    }, [memoizedParams]);

    useEffect(() => {
        if (autoFetch) {
            fetchCourseCategories();
        }
    }, [fetchCourseCategories, autoFetch]);

    return { courseCategories, loading, error, fetchCourseCategories };
}

export default useGetCourseCategories;
